<div
    class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-bg-color-unknown-108 cmps-cdk-color-white cmps-cdk-p-1 cmps-cdk-rg-0dot5"
>
    <div class="cmps-cdk-d-flex cmps-cdk-align-items-flex-start">
        <div
            class="cmps-cdk-d-flex cmps-cdk-cg-0dot5 cmps-cdk-font-size-16p cmps-cdk-font-bold"
        >
            <div>
                {{ _i18n._9422_BEHAVIOUR_ | translate }}
            </div>
            <div>
                {{
                    _service.state?.primaryFocusTag?.behaviour?.name ??
                        (_i18n._9986_NO_BEHAVIOUR_SELECTED | translate)
                }}
            </div>
        </div>
        <div class="cmps-cdk-flex-grow-1"></div>
        <div>
            <button
                cmpsIconButton
                class="cmps-icon-button--no-bg"
                [disabled]="!_service.state?.allowedActions?.editTranscript"
                [cmpsTooltipTrigger]="'Edit'"
                (click)="
                    !forNotes ? _onEditFocusClick() : _onEditNotesFocusClick()
                "
            >
                <cmps-icon
                    class="cmps-cdk-bg-color-transparent cmps-cdk-fill-white hover:cmps-cdk-fill-unknown-121"
                    svgIcon="pencil"
                ></cmps-icon>
            </button>
        </div>
    </div>
    <div
        class="cmps-cdk-d-flex cmps-cdk-flex-wrap cmps-cdk-g-0dot5"
        *ngIf="!forNotes"
    >
        <ng-container *ngFor="let tag of _service.state?.behaviourTags">
            <button
                type="button"
                class="cmps-cdk-align-items-center cmps-cdk-bg-color-transparent cmps-cdk-border-solid cmps-cdk-border-color-white cmps-cdk-border-radius-4px cmps-cdk-border-width-1p cmps-cdk-color-white cmps-cdk-d-flex cmps-cdk-font-bold cmps-cdk-font-size-12p cmps-cdk-px-0dot5 cmps-cdk-py-0 cmps-cdk-cg-0dot25 not:disabled:cmps-cdk-cursor-pointer hover:cmps-cdk-bg-color-unknown-121 focus:not:focus-visible:cmps-cdk-outline-0"
                [disabled]="!_service.state?.allowedActions?.editTranscript"
                (click)="_onRemoveBehaviourClick(tag)"
            >
                <span cmpsOutlineButtonLabel>{{
                    tag?.behaviour?.shortName
                }}</span>
                <cmps-icon
                    svgIcon="close"
                    *ngIf="_service.state?.allowedActions?.editTranscript"
                ></cmps-icon>
            </button>
        </ng-container>
        <button
            type="button"
            class="cmps-cdk-align-items-center cmps-cdk-bg-color-transparent cmps-cdk-border-solid cmps-cdk-border-color-white cmps-cdk-border-radius-4px cmps-cdk-border-width-1p cmps-cdk-color-white cmps-cdk-d-flex cmps-cdk-font-bold cmps-cdk-font-size-12p cmps-cdk-px-0dot5 cmps-cdk-py-0 cmps-cdk-cg-0dot25 not:disabled:cmps-cdk-cursor-pointer hover:cmps-cdk-bg-color-unknown-121 focus:not:focus-visible:cmps-cdk-outline-0"
            (click)="_onAddBehaviourClick()"
            *ngIf="_service.state?.allowedActions?.editTranscript"
        >
            <cmps-icon svgIcon="plus"></cmps-icon>
            <span cmpsOutlineButtonLabel>{{
                _i18n._10016_ADD_BEHAVIOUR | translate
            }}</span>
        </button>
    </div>
    <div
        class="cmps-cdk-border-radius-6p cmps-cdk-d-flex cmps-cdk-px-0dot75 cmps-cdk-py-0dot5 cmps-cdk-bg-color-unknown-124 cmps-cdk-cg-0dot5 cmps-cdk-font-size-14p"
    >
        <div>
            {{ _i18n._9423_SUB_BEHAVIOUR_ | translate }}
        </div>
        <div>
            {{
                _service.state?.primaryFocusTag?.subBehaviour?.name ??
                    (_i18n._9987_NO_SUB_BEHAVIOUR_SELECTED | translate)
            }}
        </div>
    </div>
</div>
